import React, {Component} from "react";
import {IonBadge, IonContent, IonItem, IonLabel} from "@ionic/react";
import Contest from "../../domain/Contest";

import "./SearchResult.css";
import ContestFilteredContentItem from "../../domain/ContestFilteredContentItem";
import StringUtils from "../../utils/String.utils";
import {isKnownArena} from "../../domain/SeriesItem";
import {getTypeLabelShort} from "../../domain/SeriesType";

type Props = {
  contest: Contest;
  searchValue: string;
};

type State = {}

export default class SearchResult extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    const filteredContent = this.props.contest.filterContent(this.props.searchValue);
    return (
      <IonContent>
        <div className={"search-result"}>
          {this.renderNoResults(filteredContent.length === 0)}
          {filteredContent.map((item: ContestFilteredContentItem, index: number) => this.renderSearchResultItem(item, index))}
        </div>
      </IonContent>
    );
  }

  private renderNoResults(isVisible: boolean) {
    if (!isVisible) {
      return null;
    }
    return (
      <IonLabel>
        Geen resultaten gevonden<br/>
        <small>Opgelet: zoeken start pas vanaf 3 ingegeven karakters.</small>
      </IonLabel>
    )
  }

  private renderSearchResultItem(item: ContestFilteredContentItem, index: number) {
    let hour = null;
    if (item.startHour) {
      hour = <IonBadge
        class={"search-result-badge"}>{StringUtils.pad(item.startHour, 2)}:{StringUtils.pad(item.startMinutes, 2)}</IonBadge>;
    }

    let arena = null;
    if (this.shouldShowArena(item)) {
      arena = <IonBadge class={"search-result-badge"}>{item.arena}</IonBadge>
    }

    return (
      <IonItem key={index} class={"search-result-item"}>
        <IonLabel class="label">
          <h2 className="label-content"><small>({item.headNumber})</small> {item.rider}</h2>
          <p className="label-content">{item.horse}</p>
          <p className="label-content">{item.clubName}</p>
          <small>
            <IonBadge class={"search-result-badge"}>{getTypeLabelShort(item.type)}</IonBadge>
            <IonBadge class={"search-result-badge"}>{item.difficulty}</IonBadge>
            {hour}
            {arena}
            <IonBadge class={"search-result-badge"}>{item.startNumber}</IonBadge>
          </small>
        </IonLabel>
      </IonItem>
    );
  }

  private shouldShowArena(series: ContestFilteredContentItem) {
    return ('dressage' === series.type || 'group-dressage' === series.type) && isKnownArena(series.arena);
  }
}
